import { GET_USER_KYC_INFO } from './kyc';

/**
 * What the VPN notice asks to learn whether the user's IP is allowed. The
 * backend answers 406 to an IP outside Iran on its guarded routes, so a cheap
 * authenticated GET does the job; the KYC brief is one every signed-in user
 * can read. Swap in a dedicated route once the backend adds one.
 *
 * Not `/api/v1/user/406`: that route answers 406 to everyone, Iranian IPs
 * included, so it would raise the sheet on every visit.
 */
export const VPN_PROBE_URL = GET_USER_KYC_INFO;
